import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function WhyChooseAIP() {
  const { t } = useTranslation();

  const stats = [
    { value: "200+", label: t("heroStat1"), sub: "Companies registered across East Africa" },
    { value: "7", label: t("heroStat2"), sub: "Countries we operate in" },
    { value: "98%", label: t("heroStat3"), sub: "Regulatory compliance success rate" },
    { value: "10+", label: t("heroStat4"), sub: "Years of regional expertise" },
  ];

  return (
    <section data-dark-section className="py-28 bg-[#0A1628] relative overflow-hidden">
      {/* Floating orbs */}
      <div className="absolute w-96 h-96 bg-[#00C2C2]/10 rounded-full blur-[120px] top-0 right-0 pointer-events-none" />
      <div className="absolute w-80 h-80 bg-[#E8007D]/8 rounded-full blur-[100px] bottom-0 left-0 pointer-events-none" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 sm:px-8 lg:px-16">
        <div className="grid lg:grid-cols-[1fr_2fr] gap-16 items-center">
          {/* Left text */}
          <div>
            <span className="inline-block text-xs font-bold tracking-[0.2em] text-[#00C2C2] uppercase mb-4">
              {t("whyChooseTag")}
            </span>
            <h2 className="text-4xl lg:text-5xl font-extrabold text-white leading-tight mb-6">
              {t("whyChooseTitle1")}
              <br />
              <span className="text-[#00C2C2]">{t("whyChooseTitle2")}</span>
              <br />
              {t("whyChooseTitle3")}
            </h2>
            <p className="text-white/50 text-sm leading-relaxed mb-6">
              {t("whyChooseDesc")}
            </p>
            <Link
              to="/about"
              className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 text-sm font-semibold text-[#00C2C2] border-b border-[#00C2C2]/60 pb-0.5 hover:border-[#00C2C2] transition-colors"
            >
              {t("whyCta")} <i className="ri-arrow-right-line" />
            </Link>
          </div>

          {/* Right stat cards */}
          <div className="grid sm:grid-cols-2 gap-4">
            {stats.map((s) => (
              <div
                key={s.label}
                className="group relative bg-white/5 hover:bg-white/10 border border-white/10 hover:border-[#00C2C2]/40 rounded-2xl p-8 transition-all duration-300 cursor-default overflow-hidden"
              >
                <div className="absolute top-0 left-0 right-0 h-0.5 bg-gradient-to-r from-[#00C2C2] to-[#E8007D] scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left" />
                <div className="text-5xl lg:text-6xl font-black text-white mb-2">
                  {s.value}
                </div>
                <div className="text-base font-bold text-white/90 mb-1">{s.label}</div>
                <div className="text-sm text-white/40">{s.sub}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}